import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as RadixDialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { useLayoutEffect } from 'react';
import { IconButton } from '../IconButton/IconButton.js';
import styles from './Dialog.module.css';
/** Fenêtre modale (Radix `Dialog`) : piège le focus, ferme sur Échap et sur l'overlay. */
export function Dialog({ open, defaultOpen, onOpenChange, trigger, title, description, children, footer, closeLabel, size = 'md', }) {
    // Le focus revient à l'élément qui a ouvert la fenêtre, même quand la page
    // remonte le dialogue à chaque ouverture (`key`) ou l'ouvre sans `trigger` :
    // Radix ne rend alors le focus à personne et le clavier repart du haut de la
    // page. Capturé avant que Radix ne déplace le focus (effet de mise en page,
    // qui précède les effets de ses enfants).
    useLayoutEffect(() => {
        if (!open)
            return undefined;
        const ouvreur = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        return () => {
            window.setTimeout(() => {
                const perdu = document.activeElement === document.body || document.activeElement === null;
                if (ouvreur?.isConnected && perdu)
                    ouvreur.focus();
            }, 0);
        };
    }, [open]);
    return (_jsxs(RadixDialog.Root, { open: open, defaultOpen: defaultOpen, onOpenChange: onOpenChange, children: [trigger ? _jsx(RadixDialog.Trigger, { asChild: true, children: trigger }) : null, _jsxs(RadixDialog.Portal, { children: [_jsx(RadixDialog.Overlay, { className: styles.overlay }), _jsxs(RadixDialog.Content, { className: styles.content, "data-size": size, children: [_jsxs("div", { className: styles.header, children: [_jsx(RadixDialog.Title, { className: styles.title, children: title }), _jsx(RadixDialog.Close, { asChild: true, children: _jsx(IconButton, { className: styles.close, icon: _jsx(X, { "aria-hidden": "true" }), "aria-label": closeLabel, size: "sm" }) })] }), description ? (_jsx(RadixDialog.Description, { className: styles.description, children: description })) : null, children, footer ? _jsx("div", { className: styles.footer, children: footer }) : null] })] })] }));
}
//# sourceMappingURL=Dialog.js.map